import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import s from './TopTitleBlock.module.css';
import {useTranslation} from 'react-i18next';

type Props = {
	title?: string;
	link?: string;
	pagination?: string;
};
const TopTitleBlock: React.FC<Props> = ({title, link, pagination}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	return (
		<div className="page__box">
			{link ? (
				<Link className={s.link} to={link}>
					{t(title)}
				</Link>
			) : pagination ? (
				<div className={s.pagination}>{pagination}</div>
			) : (
				<div className="page__title title">{title}</div>
			)}
			{/*<NavLink to="/" className="page__back">{titleBack} <span> </span></NavLink>*/}
			<button onClick={() => navigate(-1)} className="page__back">
				{t('назад')} <span> </span>
			</button>
		</div>
	);
};

export default TopTitleBlock;
